import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  /* align-items: center; */
  justify-content: center;
  height: 100vh;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 50px;

  > img {
    height: auto;
    width: 300px;
    margin-bottom: 20px;
  }

  h1 {
    font-size: 40px;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    color: #333;
    margin-bottom: 10px;
  }

  p {
    font-family: 'Roboto', sans-serif;
    color: #333;
  }

  p + p {
    margin-top: 10px;
  }

  a {
    text-decoration: underline;
    text-underline-offset: 1px;
  }
`;
